import {observer} from 'mobx-react-lite'
import * as React from 'react'
import {Lang} from 'yougile-lang'
import {Popup} from '../common/popup/popup'
import {RepeatEditTemplate} from './reapeat-edit-template'
import {RepeatEditFooter} from './repeat-edit-footer'
import {RepeatEditTemplateList} from './repeat-edit-template-list'
import {repeatStore} from './repeat-store'
import {useHighlightUpdater} from './use-highlight-updater'
import {useUpdateBoardId} from './use-update-board-id'

export const RepeatEdit = observer(() => {
  useHighlightUpdater()

  useUpdateBoardId()

  if (!repeatStore.state.boardId) {
    return null
  }

  const popupTitle = repeatStore.editedTpl
    ? Lang.msg.repeat.taskEditTitle
    : Lang.msg.repeat.boardEditTitle(repeatStore.getBoard()?.title || '')

  return (
    <Popup
      close={repeatStore.close}
      closeOnOverlayDisabled={true}
      footer={<RepeatEditFooter />}
      title={popupTitle}
      width={930}
      className={'repeat-popup'}
    >
      {repeatStore.state.edited ? (
        <RepeatEditTemplate />
      ) : (
        <RepeatEditTemplateList />
      )}
    </Popup>
  )
})
